import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api-base';
import { ICoverageAccount, ICoverageAccountForm } from './coverageAccount.interface';

export namespace CoverageAccountAction {
  const actionCreator = actionCreatorFactory('CoverageAccount');

  interface IUpsertParams {
    payload: ICoverageAccountForm;
    resolve: (accountId?: ICoverageAccount['accountId']) => void;
  }

  interface IRemoveParams {
    accountId: ICoverageAccount['accountId'];
    reportId: ICoverageAccount['reportId'];
    serverId: ICoverageAccount['serverId'];
  }

  interface IAccountId {
    accountId: ICoverageAccount['accountId'];
  }

  export const create = actionCreator.async<IUpsertParams, IAccountId, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<IUpsertParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<IRemoveParams, void, IApiErrorParams>('REMOVE');

  // Driven by the coverage-report list epic — accounts arrive embedded in GET /reports,
  // there is no flat accounts endpoint (and thus no epic of its own).
  export const loadList = actionCreator.async<void, ICoverageAccount[], IApiErrorParams>('LOAD_LIST');

  // Local purge after a report delete (the backend cascades its accounts).
  export const removeByReport = actionCreator<{ reportId: ICoverageAccount['reportId'] }>('REMOVE_BY_REPORT');

  export const destroy = actionCreator('DESTROY');
}
